(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/pages/cookies/cookies.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/pages/cookies/cookies.js'); 
'use strict';

const {
  logger
} = svs.termsIntegrity;
const {
  Footer,
  MainPage,
  TopMenu
} = svs.termsIntegrity.sharedComponents;
const {
  useGetCmsDataDocument,
  useGetCmsDataFolder
} = svs.termsIntegrity.sharedComponents;
const {
  DocList,
  FaqList
} = svs.termsIntegrity.sharedComponents;
const Cookies = () => {
  const [docUrl, setDocUrl] = React.useState('');
  const faqCookiesFolderId = ReactRedux.useSelector(state => state.termsIntegrity.faqCookiesFolderId);
  const cookiesFolderId = ReactRedux.useSelector(state => state.termsIntegrity.cookiesFolderId);
  const {
    data: faqData,
    loading: faqLoading,
    dataError: faqDataError
  } = useGetCmsDataFolder(faqCookiesFolderId);
  const {
    data: docData,
    loading: docLoading,
    dataError: docDataError
  } = useGetCmsDataFolder(cookiesFolderId);

  const cookieDoc = ReactRedux.useSelector(state => state.termsIntegrity.cookieDoc);
  const {
    data: docSvSData
  } = useGetCmsDataDocument(cookieDoc);
  React.useEffect(() => {
    var _svs, _svs$core, _svs$core$config, _svs$core$config$data, _svs$core$config$data2;
    const cdn = (_svs = svs) === null || _svs === void 0 ? void 0 : (_svs$core = _svs.core) === null || _svs$core === void 0 ? void 0 : (_svs$core$config = _svs$core.config) === null || _svs$core$config === void 0 ? void 0 : (_svs$core$config$data = _svs$core$config.data) === null || _svs$core$config$data === void 0 ? void 0 : (_svs$core$config$data2 = _svs$core$config$data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.cdn2;
    if (docSvSData && docSvSData.length > 0) {
      logger.debug('useEffect to get specific dokument...');
      if (docSvSData[0].documentUrl) {
        const url = cdn + docSvSData[0].documentUrl;
        setDocUrl(url);
      }
    }
  }, [docSvSData]);
  return React.createElement(React.Fragment, null, React.createElement(TopMenu, null), React.createElement(MainPage, null, React.createElement("h2", null, "Anv\xE4ndning av cookies p\xE5 Svenska Spels webbplatser"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement("p", null, "F\xF6r att du som bes\xF6kare eller inloggad kund p\xE5 Svenska Spels webbsidor och appar ska vara trygg med hur vi anv\xE4nder cookies och liknande digitala sp\xE5rningstekniker ger vi nedan en fullst\xE4ndig information om detta."), React.createElement("p", null, "F\xF6r detaljerad f\xF6rteckning av namn, typ av sp\xE5rningsteknik, \xE4ndam\xE5l, etc p\xE5 svenskaspel.se", ', ', React.createElement("a", {
    href: docUrl,
    rel: "noreferrer",
    target: "_blank"
  }, "l\xE4s mer h\xE4r"), ".")), React.createElement("div", {
    className: "margin-xs-top-1"
  }, faqDataError && React.createElement("div", null, "Fel vid h\xE4mtning av FAQ"), faqLoading && React.createElement("div", null, "Laddar faq data..."), faqData && faqData.length > 0 && React.createElement(FaqList, {
    faqList: faqData
  })), React.createElement("div", {
    className: "margin-xs-top-4"
  }, docDataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), docLoading && React.createElement("div", null, "Laddar dokument..."), docData && docData.length > 0 && React.createElement(DocList, {
    docList: docData
  }))), React.createElement(Footer, null));
};
svs.termsIntegrity.cookies.Cookies = Cookies;
 })(window);